export default __webpack_public_path__ + "static/media/viktor-liu.9206243c.jpeg";